module.exports = __webpack_public_path__ + "img/stock1.d176cfc0.png";